import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHeart = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 29.868a1.9 1.9 0 0 0 1.238-.455c1.293-1.1 2.54-2.137 3.638-3.049l.006-.003c3.225-2.678 6.009-4.988 7.944-7.266C30.992 16.55 32 14.136 32 11.5c0-2.563-.902-4.924-2.537-6.655-1.657-1.75-3.929-2.713-6.402-2.713-1.846 0-3.539.57-5.03 1.69A10.13 10.13 0 0 0 16 5.888a10.13 10.13 0 0 0-2.032-2.066c-1.49-1.12-3.18-1.686-5.029-1.686-2.47 0-4.745.963-6.402 2.713C.9 6.579 0 8.94 0 11.503c0 2.637 1.008 5.049 3.174 7.596 1.935 2.278 4.722 4.588 7.944 7.265 1.1.915 2.351 1.952 3.644 3.056.342.288.784.448 1.238.448z" /></svg>;
export default SvgHeart;